import { yupResolver } from "@hookform/resolvers/yup";
import { Form, RadioField } from "@wayflyer/flyui";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import * as Yup from "yup";

import { COMMON_MESSAGES } from "../../../common-messages";
import { MESSAGES } from "../message-definitions";

import type { Step } from "./constants";

type hasAdditionalPlatformFormFields = {
  hasAdditionalPlatform: boolean;
};

interface HasAdditionalPlatformFormProps {
  setQuestionaireStep: (step: Step) => void;
  onBack: () => void;
}

export const HasAdditionalPlatformForm = ({ setQuestionaireStep, onBack }: HasAdditionalPlatformFormProps) => {
  const intl = useIntl();

  const schema = Yup.object().shape({
    hasAdditionalPlatform: Yup.boolean().required(intl.formatMessage(MESSAGES.pleaseSelectAnOptionError)),
  });

  const form = useForm<hasAdditionalPlatformFormFields>({
    resolver: yupResolver(schema),
  });

  const {
    formState: { errors: errors },
  } = form;

  const onHasAdditionalPlatformSubmit = (formData: hasAdditionalPlatformFormFields) => {
    setQuestionaireStep(formData.hasAdditionalPlatform ? "select_additional_source" : "no_platform_reason");
  };
  const questionaire = [
    {
      value: true,
      label: intl.formatMessage(MESSAGES.canConnectAnotherOption),
    },
    {
      value: false,
      label: intl.formatMessage(MESSAGES.cannotConnectAnotherOption),
    },
  ];
  return (
    <Form
      onSubmit={form.handleSubmit(onHasAdditionalPlatformSubmit)}
      primaryAction={{
        content: intl.formatMessage(COMMON_MESSAGES.continueLabel),
        analyticsId: "revenue-air-has-additional-revenue-continue-button",
        // eslint-disable-next-line react-hooks/incompatible-library -- Existing violation after eslint-plugin-react-hooks v7 upgrade; remove when fixed.
        disabled: form.watch("hasAdditionalPlatform") === undefined,
      }}
      secondaryAction={{
        onAction: onBack,
        content: intl.formatMessage(COMMON_MESSAGES.backLabel),
        analyticsId: "revenue-air-has-additional-revenue-back-button",
      }}
    >
      <RadioField
        name="hasAdditionalPlatform"
        error={errors.hasAdditionalPlatform?.message}
        defaultValue={form.watch("hasAdditionalPlatform") ?? null}
        label={intl.formatMessage(MESSAGES.canYouConnectAnother)}
        type="block"
        options={questionaire}
        onChange={(value) => form.setValue("hasAdditionalPlatform", value as boolean)}
      />
    </Form>
  );
};
